import { distinctUntilChanged } from 'rxjs/operators';
import fastDeepEqual from 'fast-deep-equal';

export const distinctUntilChangedObject = <T>() =>
  distinctUntilChanged<T>(fastDeepEqual);
